import { css, type Theme } from "@emotion/react";

export const termsCheckbox = css`
  text-align: left;
`;

export const termsCheckboxError = (theme: Theme) => css`
  text-align: left;
  color: ${theme.warning.textBase};
  text-decoration: underline;
  text-decoration-color: ${theme.warning.textBase};
  text-underline-offset: 2px;

  a {
    color: ${theme.warning.textBase};
    text-decoration: underline;
    text-decoration-color: ${theme.warning.textBase};
  }
`;

export const asterisk = (theme: Theme) => css`
  color: ${theme.danger.textBase};
`;
